module.exports = __webpack_public_path__ + "images/generic-business-logo-small@2x-1894bede6d27fb445d32032d336397bf.png";